import { render, staticRenderFns } from "./Estatistica.vue?vue&type=template&id=d40a8474&scoped=true&"
import script from "./Estatistica.vue?vue&type=script&lang=js&"
export * from "./Estatistica.vue?vue&type=script&lang=js&"
import style0 from "./Estatistica.vue?vue&type=style&index=0&id=d40a8474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40a8474",
  null
  
)

export default component.exports